import React, { useRef, useState, useEffect } from 'react';
import { removeChildrenFromTab, addChildrenToTab } from 'utilities/tabindex.js';

import './styles.scss';

import Icon from '../icon/icon';

export default function DisclosurePanel({ children, icon_id, type, disabled }) {
  const triggerNode = useRef(null);
  const contentNode = useRef(null);

  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);

  const handleClickTrigger = () => {
    if (open) {
      animateClose();
    } else {
      animateOpen();
    }
  };

  const animateOpen = () => {
    if (open) {
      return;
    }

    const contentHeight = contentNode.current.scrollHeight;
    setHeight(contentHeight);
    setOpen(true);

    contentNode.current.addEventListener('transitionend', handleTransEnd);
    addChildrenToTab(contentNode.current);
  };

  const animateClose = () => {
    requestAnimationFrame(() => {
      const contentHeight = contentNode.current.scrollHeight;
      setHeight(contentHeight);
      requestAnimationFrame(() => {
        setHeight(0);
      });
    });

    setOpen(false);
    removeChildrenFromTab(contentNode.current);
  };

  const handleTransEnd = () => {
    setHeight('auto');
    contentNode.current.removeEventListener('transitionend', handleTransEnd);
  };

  useEffect(() => {
    removeChildrenFromTab(contentNode.current);
  }, []);

  return (
    <div class={`disclosure-panel disclosure-panel--${type}`} aria-expanded={open} data-type={type}>
      <div class="disclosure-panel__header">
        <button
          type="button"
          class="disclosure-panel__button"
          ref={triggerNode}
          disabled={disabled}
          onClick={handleClickTrigger}
        >
          {icon_id && (
            <span class="disclosure-panel__icon">
              <Icon id={icon_id} />
            </span>
          )}
          {children[0]}
        </button>
      </div>
      <div class="disclosure-panel__content" ref={contentNode} style={{ height: height }}>
        {children[1]}
      </div>
    </div>
  );
}
